import type { BrandConfig } from '../types'
import placeholderImage from './assets/placeholder.svg'
import logoImage from './assets/logo.svg'
import testimonial1 from './assets/testimonial-1.svg'
import testimonial2 from './assets/testimonial-2.svg'
import testimonial3 from './assets/testimonial-3.svg'

const config: BrandConfig = {
  appName: 'FitCore',
  brandName: 'FitCore',
  description: 'Sistema de agendamento para personal trainers',
  logo: {
    src: logoImage,
    alt: 'Logótipo da marca',
  },
  heroImage: {
    src: placeholderImage,
    alt: 'Treino personalizado em ginásio',
  },
  serviceImage: {
    src: placeholderImage,
    alt: 'Instrutor auxiliando aluno',
  },
  testimonials: [
    {
      name: 'Daniela Marques',
      role: 'Personal Trainer',
      text: 'O FitCore é o meu parceiro de treino! Consigo gerir todos os meus clientes e sessões num único local.',
      image: testimonial1,
    },
    {
      name: 'Alexandre Pinto',
      role: 'Atleta',
      text: 'Finalmente uma forma fácil de marcar os meus treinos. A flexibilidade que o sistema oferece é fantástica.',
      image: testimonial2,
    },
    {
      name: 'Ginásio BodyFit',
      role: 'Gerente',
      text: 'Este sistema simplificou a gestão dos nossos PTs e melhorou a satisfação dos nossos membros.',
      image: testimonial3,
    },
  ],
  terminology: {
    professional: 'personal trainer',
    professionals: 'personal trainers',
    business: 'estúdio',
    businesses: 'estúdios',
    service: 'treino',
    services: 'treinos',
    client: 'aluno',
    clients: 'alunos',
    appointment: 'sessão',
    appointments: 'sessões',
  },
  homepage: {
    hero: {
      badge: 'Fitness Profissional',
      title: 'Maximize seus resultados com FitCore',
      description: 'Otimize a gestão dos seus alunos e potencialize as transformações físicas com o FitCore.',
      ctaPrimary: 'Começar Gratuitamente',
      ctaSecondary: 'Agendar Demonstração',
      features: ['Setup em 5 minutos', 'App mobile incluído'],
    },
    statistics: [
      { value: '400+', label: 'Personal Trainers' },
      { value: '35k+', label: 'Sessões de Treino' },
      { value: '97%', label: 'Satisfação' },
    ],
    painPoints: [
      {
        title: 'Agenda Desorganizada',
        description: 'Gerir horários de vários alunos manualmente gera confusão e perda de sessões.',
        icon: 'Calendar',
        quote: {
          text: 'Antes do FitCore perdia 2 horas diárias só organizando os horários dos meus 15 alunos',
          author: 'Bruno Silva',
          business: 'Silva Personal Training',
        },
      },
      {
        title: 'Faltas Sem Aviso',
        description: 'Alunos que faltam última hora causam perda de rendimento e dificultam o planeamento.',
        icon: 'Users',
        stats: [
          { label: 'Taxa de ausência sem sistema:', value: '30%' },
          { label: 'Perda mensal de rendimento:', value: '800€+' },
        ],
      },
      {
        title: 'Acompanhamento de Progresso',
        description: 'Sem registos digitais, é difícil acompanhar a evolução e ajustar os treinos adequadamente.',
        icon: 'TrendingUp',
        quote: {
          text: 'Com o histórico de treinos consigo personalizar melhor e os resultados dos alunos melhoraram 60%',
          author: 'Carla Fernandes',
          business: 'Fit Evolution Studio',
        },
      },
    ],
    solution: {
      badge: 'A Solução',
      title: 'FitCore: O seu parceiro de fitness',
      description: 'Tecnologia desenhada para personal trainers que querem maximizar resultados e rentabilidade.',
      features: [
        {
          title: 'Agendamento Inteligente',
          description: 'Alunos marcam treinos respeitando sua disponibilidade e especializacão.',
        },
        {
          title: 'Acompanhamento de Progresso',
          description: 'Registe evolução, medidas e objetivos de cada aluno.',
        },
        {
          title: 'Lembretes Motivacionais',
          description: 'Reduza faltas com lembretes personalizados e motivacionais.',
        },
      ],
    },
    testimonials: {
      title: 'O que os PTs dizem',
      description: 'Personal trainers que confiam no FitCore para maximizar resultados.',
    },
    finalCta: {
      title: 'Pronto para potencializar seus treinos?',
      description: 'Junte-se a personal trainers que já maximizaram seus resultados com o FitCore.',
      ctaPrimary: 'Começar Gratuitamente',
      ctaSecondary: 'Ver Demonstração',
    },
    contact: {
      title: 'Fale Conosco',
    },
  },
  auth: {
    register: {
      title: 'Criar uma conta',
      description: 'Preencha os dados abaixo para se registrar',
      inviteDescription: 'Crie sua conta para aceitar o convite de personal trainer',
      subscriptionDescription: 'Crie sua conta para finalizar sua assinatura',
      inviteCodeLabel: 'Você está usando um código de convite',
      subscriptionLabel: 'Você selecionou um plano de assinatura',
    },
    login: {
      title: 'Entrar na conta',
      description: 'Digite suas credenciais para acessar',
    },
  },
}

export default config
